import { render, staticRenderFns } from "./ChangeUserPassword.vue?vue&type=template&id=21294963&scoped=true"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=ts"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=ts"
import style0 from "./ChangeUserPassword.vue?vue&type=style&index=0&id=21294963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21294963",
  null
  
)

export default component.exports